import { useEffect, useState } from 'react';
import { getBuzzInTotal, createBuzzCountDisplay, nextCountDelay } from '../data/buzzStatsClient';

export default function useBuzzInTotal() {
  const [total, setTotal] = useState(null);
  useEffect(() => {
    let active = true;
    let snapshot = null;
    const displayCount = createBuzzCountDisplay();
    let tick;
    const update = () => {
      if (document.hidden || !snapshot) return;
      // A lower new estimate pauses the display until it catches up.
      setTotal((previous) => Math.max(previous || 0, displayCount(snapshot)));
    };
    const animate = () => {
      update();
      tick = setTimeout(animate, nextCountDelay());
    };
    const refresh = async () => {
      if (document.hidden) return;
      const value = await getBuzzInTotal();
      if (active && value) {
        snapshot = value;
        update();
      }
    };
    refresh();
    animate();
    const timer = setInterval(refresh, 60_000);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      active = false;
      clearInterval(timer);
      clearTimeout(tick);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  return total ?? 832_880;
}
